import InscriptionColo from './InscriptionColo';

export default InscriptionColo;
